const state = {
  users: {}
}

const getters = {

}

const actions = {
  requestUserList({commit}, payload){
    const api = this._vm.$apiEndpoints;

    return new Promise((resolve, reject) => {

      this._vm.$axios.get(api.userList()).then(function(response){
                  commit("_requestUserList", response.data)
                  resolve(response.data)
                }).catch(function(response){
                  reject(response)
                })
    })
  },
  requestUserCreate({commit}, payload){
    const api = this._vm.$apiEndpoints;

    return new Promise((resolve, reject) => {

      this._vm.$axios.post(api.userCreate(), payload).then(function(response){
                  resolve(response.data)
                }).catch(function(response){
                  reject(response)
                })
    })
  },
  requestUserMoneyboxAssignmentCreate({commit}, payload){
    const api = this._vm.$apiEndpoints;
    const url = api.userMoneyboxAssignmentCreate(payload.user_id)
    var ax = this._vm.$axios;
    return new Promise((resolve, reject) => {
      
      var promises = []
      
      payload.selected_moneyboxes.forEach((item) =>{
        let prm = new Promise((resolve, reject) => {
          ax.post(url, {
              "moneybox_id": item.key
          }).finally(()=> {
            resolve()
          })
        })
        promises.push(prm)
      })

      Promise.all(promises).then(() => {
        resolve()
      })

    })
  },
  requestUserDelete({commit}, payload){
    const api = this._vm.$apiEndpoints;

    return new Promise((resolve, reject) => {

      this._vm.$axios.delete(api.userDelete(payload)).then(function(response){
                  commit("_requestUserDelete", payload)
                  resolve(response.data)
                }).catch(function(response){
                  reject(response)
                })
    })
  }
}

const mutations = {
  _requestUserList(state, payload){
    state.users = payload
  },
  _requestUserDelete(state, payload){
    state.users.users.splice(state.users.users.findIndex(item=>item.id == payload), 1)
  }
}

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
}
